import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function RepositoryConnection({project,refresh}) {
  const [repo,setRepo]=useState(project.source?.repo||"");
  const [branch,setBranch]=useState(project.base_branch||"main");
  const [confirmation,setConfirmation]=useState("");
  const [busy,setBusy]=useState(false);
  const connect=async(event)=>{
    event.preventDefault();setBusy(true);
    try{await api.post("/github/connect-project",{project_id:project.id,repo,branch,confirmation});setConfirmation("");toast.success("Repository connected");refresh();}
    catch(error){toast.error(errMsg(error));}finally{setBusy(false);}
  };
  return <section className="doc-card p-5">
    <h2 className="font-semibold mb-2">GitHub connection</h2>
    {project.source?.github_error&&<p role="status" className="text-sm text-amber-800 break-words mb-3">{project.source.github_error}</p>}
    <p className="text-sm text-slate-600 mb-3">Connect an existing repository using the configured token. Coder checks repository history before pushing. Repository creation may require permissions that the token does not have.</p>
    <form onSubmit={connect} className="grid sm:grid-cols-2 gap-3">
      <label className="text-sm">Repository (owner/name)<input className="field mono" data-testid="repository-connect-repo" value={repo} onChange={e=>setRepo(e.target.value)} required /></label>
      <label className="text-sm">Branch<input className="field mono" data-testid="repository-connect-branch" value={branch} onChange={e=>setBranch(e.target.value)} required /></label>
      <label className="text-sm">Type CONNECT-REPOSITORY<input className="field mono" data-testid="repository-connect-confirmation" value={confirmation} onChange={e=>setConfirmation(e.target.value)} required /></label>
      <button data-testid="repository-connect-submit" className="btn-primary self-end w-fit" disabled={busy||confirmation!=="CONNECT-REPOSITORY"}>{busy?"Connecting…":"Connect repository"}</button>
    </form>
  </section>;
}
